import cashQoreHttpRequestHandler from 'src/utils/cashQoreHttpRequestHandler';

class CashQoreService {
  #httpHandler;

  constructor(baseUrl, nsdToken) {
    this.#httpHandler = new cashQoreHttpRequestHandler(baseUrl, nsdToken);
  }

  createStipeAccount = async connectedAccountCreateRequest => {
    let res = await this.#httpHandler.post(
      'e-payment/stripe/create-connected-account',
      connectedAccountCreateRequest
    );

    return res.data;
  };

  verifyStipeAccount = async accountInfo => {
    const res = await this.#httpHandler.get(
      `e-payment/stripe/connected-account-onboarding-workflow-status?stripeAccountId=${accountInfo.stripeAccountId}`
    );

    return res.data;
  };

  getStipeAccountOnboardingUri = async accountInfo => {
    const res = await this.#httpHandler.post(
      'e-payment/stripe/connected-account-onboarding-workflow',
      { connectedAccountOnboardWorkflowRequest: accountInfo }
    );
    return res.data;
  };

  getTransactions = async transactions => {
    const res = await this.#httpHandler.post('e-payment/stripe/transactions', {
      transactions
    });
    return res.data;
  };

  getPayoutDetail = async payoutId => {
    const res = await this.#httpHandler.get(
      `e-payment/stripe/payout-detail?stripeAccountPayoutId=${payoutId}`
    );
    return res.data;
  };

  getGhostCardPdf = async purchaseLogId => {
    const res = await this.#httpHandler.get(
      `e-payment/wex/get-card-pdf?purchaseLogId=${purchaseLogId}`
    );
    return res.data;
  };
}

const cashQoreService = new CashQoreService(
  process.env.REACT_APP_CASH_QORE_API,
  null
);

export default cashQoreService;
